import { axiosRequest } from './instance';
import { TenantId } from './tenants/Tenant';

export interface EnrichedMentorResponse {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  about?: string;
  linkedInProfile?: string;
  currentRole?: string;
  companyName?: string;
  seniority?: string;
  experienceYears?: number;
  dateOfBirth?: string;
  isEnterpreneur?: boolean;
  isInvestor?: boolean;
  skills?: string;
  mentorCapacity?: number;
  specializations?: string[];
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  mentorAdditionalInfo?: {
    gender?: string;
    race?: string;
    whyBecomeMentor?: string;
    businessChallenges?: string;
  };
}

export interface EnrichedFounder {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  linkedInProfile?: string;
  about?: string;
  currentRole?: string;
  education?: string;
  gender?: string;
  race?: string;
}

export interface EnrichedVentureResponse {
  ventureName?: string;
  url?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  ventureStage?: string;
  businessModel?: string;
  businessDescription?: string;
  numOfEmployees?: string;
  isTech?: string;
  currentProgress?: string;
  description?: string;
  founders?: EnrichedFounder[];
  specializations?: string[];
  mentorshipNeeds?: string;
  matchingNotes?: string;
}

const enrichAPI = {
  async enrichMentorFromFile(tenantId: TenantId, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosRequest.post<EnrichedMentorResponse>({
      url: `/public/tenants/${tenantId}/mentors/enrich/files`,
      data: formData,
      credentials: false,
      timeout: 120000,
    });
    return res.data;
  },

  async enrichVentureFromFile(tenantId: TenantId, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosRequest.post<EnrichedVentureResponse>({
      url: `/public/tenants/${tenantId}/ventures/enrich/files`,
      data: formData,
      credentials: false,
      timeout: 120000,
    });
    return res.data;
  },
};

export default enrichAPI;
